import React from 'react';
import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';
const testimonials = [{
  name: 'Carla R.',
  location: 'CDMX',
  quote: 'Pasé de gastar $150 al mes en cremas que no hacían nada, a gastar $30 cada tres meses. Mi piel nunca estuvo tan luminosa. El protocolo de 28 días es infalible.',
  result: 'Adiós textura y poros abiertos en 3 semanas.'
}, {
  name: 'Laura M.',
  location: 'Madrid',
  quote: "Tenía pánico de usar Retinol porque tengo la piel sensible. Con el método 'Sándwich' de este libro, mi cara cambió por completo sin una sola rojez. Es magia de farmacia.",
  result: 'Manchas de acné desaparecidas en 1 mes.'
}, {
  name: 'Dra. Sofía G.',
  location: 'Buenos Aires',
  quote: 'Soy dermatóloga y me impresiona lo bien explicado que está el concepto de pH y moléculas. Se lo recomiendo a mis pacientes que no pueden costear marcas de nicho.',
  result: 'Pacientes con barrera cutánea sana.'
}];
export function TestimonialsSection() {
  return <section className="py-14 md:py-24 px-6 bg-white" data-id="element-221">
      <div className="max-w-5xl mx-auto" data-id="element-222">
        <div className="text-center mb-10 md:mb-16" data-id="element-223">
          <h2 className="text-3xl md:text-5xl font-bold mb-6" data-id="element-224">
            Resultados Reales, Sin Filtros
          </h2>
          <div className="flex justify-center gap-1 mb-4" data-id="element-225">
            {[...Array(5)].map((_, i) => <Star key={i} className="w-6 h-6 fill-gold text-gold" data-id="element-226" />)}
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-5 md:gap-8" data-id="element-227">
          {testimonials.map((t, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.2
        }} className="bg-cream p-8 rounded-xl border-l-4 border-gold shadow-sm relative" data-id="element-228">
              <Quote className="absolute top-4 right-4 w-8 h-8 text-gold/20" data-id="element-229" />
              <p className="text-charcoal/80 italic mb-6 relative z-10" data-id="element-230">
                "{t.quote}"
              </p>
              <div className="mt-auto" data-id="element-231">
                <p className="font-bold text-charcoal font-serif" data-id="element-232">{t.name}</p>
                <p className="text-sm text-charcoal/50 mb-4" data-id="element-233">{t.location}</p>
                <div className="bg-sage/10 text-sage-800 p-3 rounded text-sm font-medium border border-sage/20" data-id="element-234">
                  <span className="text-sage font-bold" data-id="element-235">Resultado:</span>{' '}
                  {t.result}
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}